/**
 * 作者：张小彤
 * 时间：2016/12/12
 * 描述：问题文件
 */
import React, {Component} from 'react';

import './ques.scss';

export default class Ques extends Component{
    render(){
        return(
            <div className="tabcon none">
                <div className="quescon">
                    <div className="queconblock">
                        <h2>1. 自主SDK支付界面打不开</h2>
                        <div className="quemess">
                            <p><i>答: </i>（1）检查初始m是否正确以及调用支付接口是传入的 区服ID (网关ID)是否正确，可通过客户端打印日志查看。</p>
                            <p><i></i>（2）传入都正确的前提下联系确认对应的区服是否有开启支付功能，有些区服（如：测试服）可能本身就没有开启支付功能。</p>
                            <p><i></i>（3）在前两天都没问题的前提下想平台确认充值服务器是否部署。</p>
                        </div>
                    </div>
                    <div className="queconblock">
                        <h2>2. 自主SDK正式环境测试环境如何切换？</h2>
                        <div className="quemess">
                            <p><i>答: </i>客户端在asset目录的property.cfg文件中有LK_Test 自带，true标识测试环境，false标示正式环境；如果没有LK_Test字段则会</p>
                            <p><i></i>有mode.debug 字段，true标示测试环境， false标示正式环境。</p>
                            <p className="zhuyi">注意：在用SDK正式环境或测试环境是，请确保服务器与蓝港服务器连接环境保持一致。</p>
                        </div>
                    </div>
                    <div className="queconblock bmnone">
                        <h2>3. 登录失败</h2>
                        <div className="quemess">
                            <p><i>答: </i>（1）检查客户端打印的日志是否配置了正确的蓝港gameId。</p>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./D:/front-end-svn/webpack/src/project/sdk/components/quesition/ques.jsx